import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SessionDataService } from '../service/session-data.service';

@Component({
  selector: 'app-more-info-dialog',
  templateUrl: './more-info-dialog.component.html',
  styleUrls: ['./more-info-dialog.component.css']
,
  standalone: false
})
export class LogMoreInfoDialogComponent implements OnInit {
  displayedColumns: string[] = ['key', 'value'];
  dataSource: MatTableDataSource<{ key: string; value: any }>;

  constructor(
    public dialogRef: MatDialogRef<LogMoreInfoDialogComponent>,
    private dataService: SessionDataService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    const dataAdd:any = this.dataService.flattenObject(this.data);
    delete dataAdd?.readme;
    const dataArray = Object.keys(dataAdd).map(key => ({ key, value: dataAdd[key] }));
    dataArray.sort((a, b) => {
      if (a.key < b.key) return -1;
      if (a.key > b.key) return 1;
      return 0;
    });
    console.log("PST", dataArray);
    this.dataSource = new MatTableDataSource(dataArray);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
